

import Vue from "vue";

import {Project} from "@/models/base";

export default Vue.extend({
	data() {
		return {
		};
	},
	props: {
		project: {
			required: true,
			type: Object as () => Project
		},
	},
	methods: {
		save(){
			this.$emit("save");
		}
	},
	i18nEx: {
		componentPrefix: "components.project"
	}
});
	